import ls from 'local-storage';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { COMMON_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import { getCombinedRequestFiltersAsJS } from '../selectors/validationSelectors';

const saveCommonCacheThunk = () => (dispatch, getState) => {
  const state = getState();
  const request = getCombinedRequestFiltersAsJS(state);
  ls.set(COMMON_LOCAL_STORAGE_CACHE_KEY, {
    ...request.startLocation && {
      from: {
        label: request.startLocation.label,
        type: request.startLocation.type,
        id: request.startLocation.id,
        airportCode: request.startLocation.airportCode,
      },
    },
    ...request.endLocation && {
      to: {
        label: request.endLocation.label,
        type: request.endLocation.type,
        id: request.endLocation.id,
        airportCode: request.endLocation.airportCode,
      },
    },
    startDate: request.startDate,
    endDate: request.endDate,
    timestamp: Date.now(),
    locale: getActiveLocaleSelector(state),
    version: 3,
  });
};

export default saveCommonCacheThunk;
